export class GetRenewalContractTextRequest {
    Rmr: number;
}